import http from '@/utils/http';
import i18n from '@/main';

const baseUrl = '/rastreabilidade/exportacao';

export default {
    createIndividualExportRecord(formData) {
        return http.post({
            url: `${baseUrl}/inserir`,
            data: formData,
            lockScreen: true
        });
    },

    getTotalizers() {
        return http.get({
            url: `${baseUrl}/totalizadores`,
            lockScreen: false
        });
    },

    fetchIndividualExportRecordById(id) {
        return http.get({
            url: `${baseUrl}/${id}/buscar-exportacao`,
            lockScreen: true
        });
    },

    generateExportFile(idTransacao) {
        return http.get({
            url: `${baseUrl}/gerar-arquivo/${idTransacao}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload'),
            responseType: 'blob'
        });
    }
};
